import { Types } from './../Models/TerminalInstallationModel';
import { EnumTypes } from './../Models/EnumTypes/PageEnumTypes';
import { EnumTypes as TerminalInstallationEnumTypes } from './../Models/EnumTypes/TerminalInstallationEnumTypes';
import { TerminalInstallationActions } from 'Redux/Actions/TerminalInstallationActions';
import * as TerminalInstallationConnector from './../Connectors/TerminalInstallationConnector';

export { Types, TerminalInstallationConnector as Connector, EnumTypes, TerminalInstallationEnumTypes, TerminalInstallationActions as Actions };



// WEBPACK FOOTER //
// ./src/Modules/TerminalInstallationModule.ts